import { fiatWalletsRoutes } from './fiatWallets/fiatWalletsRoute'
import { cryptoWalletsRoutes } from './cryptoWallets/cryptoWalletsRoute'

import type { RouteRecordRaw } from 'vue-router'

// Note: the legacy `depositRequests` sub-module (the old wallets-side
// deposit requests UI at `/wallets/deposit-requests`) has been
// superseded by `src/modules/treasury/depositRequests/` which mounts
// the new work-queue at `/treasury/deposit-requests`. Its route is
// no longer registered here. The legacy module files remain on disk
// for now — a separate cleanup pass should delete them.
export const walletsRoutes: RouteRecordRaw[] = [...fiatWalletsRoutes, ...cryptoWalletsRoutes]
